// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { resolveInitialLanguage } from './utils/languageUtils';

const initialLanguage = resolveInitialLanguage();
console.log('[i18n] Initial language:', initialLanguage);

/* global __I18N_BUILD_ID__ */
// Build stamp injected by vite.config.js `define`. Test runners and any other
// bundler that does not define it fall back to a constant, which keeps the
// request shape identical without pretending to be a real build id. `typeof`
// is required here: a bare reference to an undeclared global would throw.
const translationBuildId = typeof __I18N_BUILD_ID__ === 'string'
  ? __I18N_BUILD_ID__
  : 'dev';

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    lng: initialLanguage,
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
      // Cache-bust per build: the URL changes only when the app is rebuilt, so
      // translations stay browser-cached within a deployment but can never be
      // served stale across one.
      queryStringParams: { v: translationBuildId },
    },
    react: {
      useSuspense: false // Set this to false
    },
    detection: {
      // Configure language detector to use a separate key to avoid conflicts
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage']
    }
  });

export default i18n;
